import { useSelector } from "react-redux";
import clsx from "clsx";
import { isCompleteFilterUrl } from "~/utils/catalog/filterUrl";
import styles from "./index.module.scss";
import Hint from "../../../../common/hint";

export default function Props({ props, filterUrl }) {
  const { props: allProps } = useSelector((state) => state.props);
  return (
    <>
      {props?.map((prop) => (
        <div key={prop.ID} className={clsx(styles.Prop)}>
          <span className={clsx(styles.PropName)}>
            {allProps[prop.CODE]?.NAME || prop.NAME}
            {allProps[prop.CODE]?.HINT && (
              <div className={styles.Hint}>
                <Hint text={allProps[prop.CODE]?.HINT} />
              </div>
            )}
          </span>

          <span className={clsx(styles.PropValue)}>
            {prop.VALUE}
            {(prop.NAME === "Электрика в комплекте" ||
              prop.CODE === "ELEKTRIKA_V_KOMPLEKTE") &&
              prop.VALUE === "нет" &&
              isCompleteFilterUrl(filterUrl) && (
                <a href={`/catalog/elektrika_farkopov/filter/${filterUrl}`}>
                  подобрать
                </a>
              )}
          </span>
        </div>
      ))}
    </>
  );
}
